import Picker from '../../picker/locale/ru_RU';
import DatePicker from '../../date-picker/locale/ru_RU';
import DatePickerView from '../../date-picker-view/locale/ru_RU';
import Menu from '../../menu/locale/ru_RU';
// import Calendar from '../../calendar/locale/ru_RU';
import SearchBar from '../../search-bar/locale/ru_RU';
import InputItem from '../../input-item/locale/ru_RU';
import Pagination from '../../pagination/locale/ru_RU';
import PullToRefresh from '../../pull-to-refresh/locale/ru_RU';
import ActionSheet from '../../action-sheet/locale/ru_RU';

export default {
  locale: 'ru_RU',
  Picker,
  DatePicker,
  DatePickerView,
  Menu,
  // Calendar,
  SearchBar,
  InputItem,
  Pagination,
  PullToRefresh,
  ActionSheet
};
